import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Form, Icon, message, Modal, Row, Tag } from 'antd';
import * as CommonService from '../../../services/CommonService';
import { INVOICE_ENDPOINT, INVOICE_REFUND_ENDPOINT, TEMPLATE } from '../../../services/endpoint';
import { useHistory, useParams } from 'react-router-dom';
import { dateToString } from '../../../utils';
import { ORDER_STATUS } from '../../../utils/const';
import CustomerInformation from './components/CustomerInformation';
import OrderInformation from './components/OrderInformation';
import ProductInformation from './components/ProductInformation';
import PaymentInfo from './components/PaymentInfo';

const { confirm } = Modal;

const OrderDetail = () => {

	const { id } = useParams();

	const history = useHistory();

	const [orderDetail, setOrderDetail] = React.useState({});
	const [rerender, setRerender] = React.useState(0);
	const [paymentHistory, setPaymentHistory] = useState([]);

	const init = async () => {
		try {
			window.setLoading(true);
			const resp = await Promise.all([CommonService.findById(INVOICE_ENDPOINT, id)]);
			const [orderRes] = resp;
			setOrderDetail(orderRes?.data || {});
			if (orderRes?.data?.invoiceRefundId) {
				const history = await CommonService.get(`${INVOICE_REFUND_ENDPOINT}/${orderRes?.data?.invoiceRefundId}/payment-history`);
				setPaymentHistory(history?.data || []);
			} else {
				const history = await CommonService.get(`${INVOICE_ENDPOINT}/history`, { id });
				setPaymentHistory(history?.data || []);
			}
		} catch (err) {
			message.error(err?.data?.message || 'Có lỗi xảy ra');

		} finally {
			window.setLoading(false);
		}
	};

	useEffect(() => {
		init();
	}, []);

	const renderStatus = (status) => {
		const currStatus = ORDER_STATUS.find(el => el.value === status);
		return currStatus &&
			<Tag style={{ width: '100px', textAlign: 'center' }} color={currStatus.color}>{currStatus.name}</Tag>;
	};

	useEffect(() => {
		if (rerender !== 0) {
			init();
		}
	}, [rerender]);

	const handleCancel = () => {
		confirm({
			icon: 'warning',
			width: '510px',
			title: 'Hủy đơn hàng',
			okType: 'danger',
			content: <>Bạn có chắc chắn muốn hủy đơn hàng này không?
				<br />
				Thao tác này không thể khôi phục.</>,
			onOk() {
				window.setLoading(true);
				CommonService.update(INVOICE_ENDPOINT, id, { action: 'Cancel' }).then(res => {
					if (res.status === 200) {
						message.success('Hủy đơn hàng thành công');
						setRerender(Math.random());
					}
				}).catch(err => {
					message.error(err?.data?.message);
				}).finally(() => window.setLoading(false));
			},
			onCancel() {
				console.log('Cancel');
			},
			cancelText: 'Thoát',
			okText: 'Hủy đơn hàng'
		});
	};

	const handlePrint = async () => {
		try {
			window.setLoading(true);
			const res = await CommonService.get(`${TEMPLATE}/invoice/${id}`, {});
			let data = res?.data.replace('<title>', '').replace('</title>', '').replace('Title', '');

			const iframe = document.createElement('iframe');
			iframe.style.position = 'fixed';
			iframe.style.right = '0';
			iframe.style.bottom = '0';
			iframe.style.width = '0';
			iframe.style.height = '0';
			iframe.style.border = '0';
			document.body.appendChild(iframe);

			const iframeDoc = iframe.contentWindow || iframe.contentDocument;
			iframeDoc.document.open();
			iframeDoc.document.write(data);
			iframeDoc.document.close();

			// iframe.onload = () => {
			// 	iframe.contentWindow.focus();
			// 	iframe.contentWindow.print();

			// 	setTimeout(() => {
			// 		document.body.removeChild(iframe);
			// 	}, 1000);
			// };
			setTimeout(() => {
				iframe.contentWindow.focus();
				iframe.contentWindow.print();
			  
				setTimeout(() => {
				  document.body.removeChild(iframe);
				}, 500);
			  }, 500);
		} catch (e) {
			message.error('Có lỗi xảy ra, vui lòng thử lại sau');
			console.log(e);
		} finally {
			window.setLoading(false);
		}
	};


	return (
		<Fragment>
			{orderDetail.status === 'COMPLETED' && <Row>
				<Col span={24} className={'mb-10'} style={{ textAlign: 'right' }}><Button type={'primary'}
																																									onClick={() => history.push('/customer-refund/create?id=' + orderDetail.id)}>Tạo
					đơn trả hàng</Button></Col>
			</Row>}
			{!['COMPLETED', 'CANCELED'].includes(orderDetail.status) && <Row>
				<Col span={24} className={'mb-10'} style={{ textAlign: 'right' }}><Button type={'danger'}
																																									onClick={handleCancel}>Hủy đơn
					hàng</Button></Col>
			</Row>}
			<Row>
				<Col span={20}><p>
					Mã đơn hàng: <b>{orderDetail?.invoiceCode || ''}</b> <span
					style={{ color: '#b9b0b0' }}>{dateToString(orderDetail.createdDate)}</span>
				</p>
				</Col>
				<Col span={4} style={{ textAlign: 'right' }}>
					<p>
						{renderStatus(orderDetail.status)}
					</p>
				</Col>
				<Col span={24} className={'mb-10'}>
					<Button onClick={handlePrint}>
						<Icon type="printer" style={{ fontSize: 25 }} />
					</Button>
				</Col>
			</Row>
			<Row gutter={12} className={'mt-10'}>
				<Col span={16}>
					<CustomerInformation orderDetail={orderDetail} />
				</Col>
				<Col span={8}>
					<OrderInformation orderDetail={orderDetail} />
				</Col>

			</Row>
			<Row>
				<Col>
					<PaymentInfo orderDetail={orderDetail} setRerender={setRerender} paymentHistory={paymentHistory}
											 setPaymentHistory={setPaymentHistory} />
				</Col>
				<Col>
					<ProductInformation
						detail={orderDetail}
					/>
				</Col>
			</Row>
			<Col style={{ textAlign: 'right', marginTop: 10 }}>
				<Button style={{ marginRight: '5px' }} onClick={() => history.push('/orders')}>Thoát</Button>
			</Col>
		</Fragment>
	);
};
export default Form.create({ name: 'OrderDetail' })(OrderDetail);
